<template>
  <b-alert
    v-if="userInQueue>0"
    variant="warning"
    class="mb-0"
    fade
    :show="!isHide"
    @dismissed="isHide = true"
  >
    <div class="alert-body text-center">
      {{ $t("general.peopleAreInQueued", { number: userInQueue}) }}
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import useJwt from '@/auth/jwt/useJwt'

const QueueRepository = Repository.get('queueRepository')

export default {
  components: {
    BAlert,
  },
  data() {
    return {
      loading: false,
      isHide: false,
      userInQueue: 0,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile?.email || this.$store.state.profile?.phone
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName))
    },
    isVerify() {
      if (this.$store.state.profile.isVerify) {
        return this.$store.state.profile.isVerify
      }
      return this.userData.isVerify
    },
  },
  beforeDestroy() {
    clearInterval(this.getUserInQueue)
  },
  mounted() {
    this.getUserInQueue()
    this.getUserInQueue = setInterval(this.getUserInQueue, 5000)
  },
  methods: {
    getUserInQueue() {
      QueueRepository.get({ merchantId: this.userData?.merchantId })
        .then(response => {
          const data = response?.data?.data
          if (data) {
            this.userInQueue = data.total
          }
        })
        .catch(error => { })
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>
